function info() {
  return (
    <main>
       <section className="info">
         <div className='container'>
            <div className='row'>
              <div class="col-12 col-lg-6">
                <h2 className="info-header">Meet MarkdownMagic.</h2>
                <p className="info-paragraph">With our stunning Markdown previewer, get a clear, live display of your Markdown inputs. With MarkdownMagic, what you see is what you get!</p>
              </div>
            </div>
         </div>
       </section>
     </main>
  );
}

export default info;
